export default __webpack_public_path__ + "static/media/syncImage.063fb502.png";